import React from 'react';
import './mobileHome.css';
import 'primereact/resources/themes/lara-light-cyan/theme.css';
import AppIcon from '../../../assets/images/AI_Assistant_App_logo.svg';
import ResponseStatus from './ResponseStatus';
import successIcon from '../../../assets/images/green_success_icon.png';
import failureIcon from '../../../assets/images/device_not_allowed.svg';
import spinnerIcon from '../../../assets/images/spinner.svg';
import greenCheckIcon from '../../../assets/images/verified_check.svg';
// import userIcon from '../../../assets/images/user.svg';
// import deviceIcon from '../../../assets/images/device.svg';
import userIcon from '../../../assets/images/user_blue.svg';
import deviceIcon from '../../../assets/images/device_blue.svg';
import userFailureIcon from '../../../assets/images/user_failure.svg';
import deviceFailureIcon from '../../../assets/images/device_failure.svg';

const MobileHome = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const userName = searchParams.get('userName');
    const userEmail = searchParams.get('userEmail');
    const deviceName = searchParams.get('deviceName');
    const deviceMac = searchParams.get('macId');
    const status = searchParams.get('status');
    const msg = searchParams.get('msg');
    const userStatus = searchParams.get('userStatus');

    const validStatus = (status) => {
        return (
            status !== 'INTERNAL_SERVER_ERROR' &&
            status !== 'INVALID_SESSION_ID'
        );
    };

    return (
        <div className='mobile-page-layout'>
            <div className='mobile-page'>
                <div className='device-header'>
                    <div className='app_logo'>
                        <img src={AppIcon} />
                    </div>
                    <div>Samsung AI Assistant</div>
                </div>
                <main className='main'>
                    <div className='message'>
                        {status === 'Success' ? (
                            <ResponseStatus
                                message={msg}
                                responseImg={successIcon}
                            />
                        ) : status === 'Failure' ||
                          status === 'INTERNAL_SERVER_ERROR' ||
                          status === 'INVALID_SESSION_ID' ? (
                            <ResponseStatus
                                message={
                                    status === 'INTERNAL_SERVER_ERROR'
                                        ? 'Internal Server Error'
                                        : msg
                                }
                                responseImg={failureIcon}
                            />
                        ) : (
                            <ResponseStatus
                                message={msg}
                                responseImg={spinnerIcon}
                            />
                        )}
                    </div>
                    <div className='entries'>
                        {validStatus(status) && (
                            <div className='entry'>
                                <div className='badge'>
                                    <img src={userIcon} />
                                </div>
                                <div className='info'>
                                    <div className='mobile_user_info mobile_name_title'>
                                        {userName}
                                    </div>
                                    <div className='mobile_user_info mobile_name_subtitle'>
                                        {userEmail}
                                    </div>
                                </div>
                                <div className='badge'>
                                    {status === 'Success' ||
                                    userStatus == 'true' ? (
                                        <img src={greenCheckIcon} />
                                    ) : status === 'Failure' ? (
                                        <img src={userFailureIcon} />
                                    ) : (
                                        <div
                                            style={{ marginLeft: '1rem' }}
                                        ></div>
                                    )}
                                </div>
                            </div>
                        )}
                        {validStatus(status) && (
                            <div className='entry'>
                                <div className='badge'>
                                    <img src={deviceIcon} />
                                </div>
                                <div className='info'>
                                    <div className='mobile_device_info mobile_name_title'>
                                        {deviceName}
                                    </div>
                                    <div className='mobile_device_info mobile_name_subtitle'>
                                        {deviceMac}
                                    </div>
                                </div>
                                <div className='badge'>
                                    {status === 'Success' ||
                                    status === 'Pending' ? (
                                        <img src={greenCheckIcon} />
                                    ) : (
                                        <img src={deviceFailureIcon} />
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </main>
            </div>
        </div>
    );
};

export default MobileHome;
